import { useContext } from 'react';
import { JobsContext, IJobsContext } from './contexts';

export function useJobs(): IJobsContext {
    return useContext(JobsContext);
}
